import * as urlTemplate from 'url-template';
import { CookieService } from 'ngx-cookie-service';

import { environment as ENV } from '@environment';
import { LoginType } from '@app/entities/login-type';
import { userHistoryAuth, userHistoryRoute } from '@app/modules/user-history/constants/history-routes.constants';
import { CheckoutWebSessionKey, CheckoutWebSessionType } from '@app/constants/checkout-web.constans';
import { AppWindow } from '@app/entities/app-window';

declare const window: AppWindow;

export function validateSessionCookies(cookieService: CookieService): boolean {
  const cookieRappiId = cookieService.get(CheckoutWebSessionKey.Id);
  const cookieRappiTypeId = cookieService.get(CheckoutWebSessionKey.Type);
  try {
    if (cookieRappiId && cookieRappiTypeId &&
      cookieRappiTypeId === CheckoutWebSessionType.Authenticated) {
      const token = JSON.parse(atob(cookieRappiId));
      return !!token?.access_token;
    } else return false;
  } catch (error) {
    return false;
  }
}

export function authTokenSessionCookies(cookieService: CookieService): string | null {
  try {
    const cookieRappiId = cookieService.get(CheckoutWebSessionKey.Id);
    if (validateSessionCookies(cookieService)) {
      const token = JSON.parse(atob(cookieRappiId));
      return token?.access_token;
    } else return null;
  } catch (error) {
    return null;
  }
}

export function redirectToLogin(loginType: LoginType, currentUrl?: string): void {
  let url = '';
  switch (loginType) {
    case LoginType.Booking:
      url = urlTemplate.parse(ENV.web_login).expand({
        redirect: `${ENV.urlPath}/${currentUrl}`
      });
      break;
    case LoginType.Anywhere:
      url = urlTemplate.parse(ENV.web_login).expand({
        redirect: window.location.href
      });
      break;
    default:
      url = urlTemplate.parse(ENV.web_login).expand({
        redirect: `${ENV.urlPath}/${userHistoryRoute}/${userHistoryAuth}`
      });
      break;
  }
  window.location.href = url;
}

export const endCallWebView = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  if (window.app !== undefined) {
    window.app.endCall();
  }
  if (window.appInterface !== undefined) {
    window.appInterface.endCall();
  }
  if (window.webkit !== undefined) {
    window.webkit.messageHandlers.endCall.postMessage('');
  }
}
